import SwitchUserPage from '@/views/profile/SwitchUserPage'

export default function SwitchUser() {
  return <SwitchUserPage />
}
